import { Checkbox } from "@/components/ui/checkbox";

const BOXES = [
  { key: "consent_account", testId: "consent-account",
    text: "I agree to receive messages by WhatsApp and email about my account, payments, access renewals and my child's progress." },
  { key: "consent_marketing", testId: "consent-marketing",
    text: "I agree to receive news, offers and new features from Anou Appran by WhatsApp and email." },
];

export default function ConsentBoxes({ value, onChange }) {
  return (
    <div className="space-y-2.5">
      {BOXES.map((b) => (
        <label key={b.key} className="flex items-start gap-2.5 text-sm text-slate-700 cursor-pointer">
          <Checkbox checked={!!value[b.key]} onCheckedChange={(c) => onChange({ ...value, [b.key]: c === true })}
            className="mt-0.5 border-2 border-slate-900" data-testid={b.testId} />
          <span>{b.text} <span className="text-slate-400">(optional)</span></span>
        </label>
      ))}
    </div>
  );
}
